import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceKey } from '../../utils/keys';
import { useCachedSpace } from '../cache';
export const useSpace = (options) => {
    const { variables, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const cachedSpace = useCachedSpace(variables);
    const spaceKey = getSpaceKey({ variables, fields });
    return useQuery(spaceKey, () => client.spaces.get(variables, fields), {
        placeholderData: () => cachedSpace,
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useSpace.js.map